import Navigation from 'components/Navigation';
import Slide from 'components/Slide';

const Home = () => {
  return (
    <div>
      <Slide title="React + TypeScript">
        <Navigation />
      </Slide>
    </div>
  );
};

export default Home;
